<template>
  <header class="header" :class="classes">
    <router-link to="/">
      <spk-logo class="header__logo"/>
    </router-link>

    <ul v-if="mobile" class="header__social">
      <li v-for="account in social.accounts" class="header__account">
        <a :href="account.url" target="_blank"><icon :id="account.icon"/></a>
      </li>
    </ul>

    <mobile-menu v-if="mobile" :expand="expand" :links="links" @menu-close="expand = false"/>
    <button v-if="mobile" class="burger" :class="burgerState" @click="expand = !expand"><i class="burger--icon"></i></button>

    <nav v-if="!mobile">

      <router-link v-for="link in links" :to="link.path" class="header__link">{{ link.label }}</router-link>
      <router-link to="/infolettre" class="header__link header__link--cta">
        <icon id="newsletter"/>
        <span>Infolettre</span>
      </router-link>
    </nav>
  </header>
</template>

<script>
import MobileMenu from './MobileMenu'

export default {
  name: 'header-nav',
  components: { MobileMenu },
  props: { modifier: String },

  data() {
    return {
      expand: false
    }
  },

  computed: {
    mobile() { return this.$media.mobile },
    links() { return this.$store.state.content.meta.links },
    social() {
      return {
        accounts: this.$store.state.content.meta.accounts,
        label: this.$store.state.content.meta.label
      }
    },
    classes() {
      return {
        [`header--${this.modifier}`]: this.modifier,
        'header--menu-open': this.expand
      }
    },
    burgerState() {
      return {
        'burger--close': this.expand
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HeaderNav.vue?83f27eba